import NewMemberAnalytics from 'routes/NewMemberAnalytics/NewMemberAnalytics';

export default NewMemberAnalytics;
